
const snack = require('../../../../../components/snack/snack')

export function start(detail) { //console.log('snack Type -> ', detail)
  snackBody[detail.id].start(detail.addTitle)

  detail.html = snackBody[detail.id]
  snack.start(detail)

}

const snackBody = {

  noAction: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function () {
      this.title = 'No Action'        //language.start('inProgress')     
    }
  },

  invalidValue: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                      "click": [
                          {"dest":"ripple" },
                          {"dest":"snack", "act":"hide"}
      ]}'`,


    start: function () {
      this.title = 'Invalid Value'        //language.start('inProgress')     
    }
  },

  ErrorUpdate: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                      "click": [
                          {"dest":"ripple" },
                          {"dest":"snack", "act":"hide"}
      ]}'`,


    start: function () {
      this.title = 'An error occurred while updating.'        //language.start('inProgress')     
    }
  },

  insufficientQuantity: { 
    title: '', 
    btn: '',
    class:``,

      dataDetail:`data-detail='{
                      "click": [
                          {"dest":"ripple" },
                          {"dest":"snack", "act":"hide"}
      ]}'`,


    start: function(){  
      this.title   = 'You can not type more items than those available'        //language.start('inProgress')     
      // this.btn     = 'Undo'        //language.start('inProgress')     

    }
  },
  SuccessUpdate: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                      "click": [
                          {"dest":"ripple" },
                          {"dest":"snack", "act":"hide"}
      ]}'`,


    start: function () {
      this.title = 'Data Updated'        //language.start('inProgress')     
    }
  },

  noPurchase: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function () {
      this.title = 'Purchases not found'        //language.start('inProgress')     
    }
  },

  allInputEmpty: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function () {
      this.title = 'Complete at least one field'        //language.start('inProgress')     
    }
  },

}